import styled from 'styled-components';

export const Container = styled.div`
	width: 100%;
	position: relative;
	display: flex;
	min-height: 180px;
	background-color: #f5f7fa;
	padding: 32px 18px 18px 18px;
	gap: 12px;
`;

export const ContainerIcon = styled.div`
	position: absolute;
	top: -32px;
	left: 12px;
`;

export const ContainerContent = styled.div`
	display: flex;
	gap: 12px;

	@media (max-width: 1250px) {
		display: grid;
		grid-template-columns: 1fr 1fr 1fr;
	}
`;
